import { useWindowDimensions } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

export type ProportionSizeProps = {
  readonly proportion: number;
  readonly aspectRatio: number;
};

export type ProportionSizeType = {
  readonly width: number;
  readonly height: number;
};

export function useProportionSize(
  props: ProportionSizeProps,
): ProportionSizeType {
  const { proportion, aspectRatio } = props;
  const { width } = useWindowDimensions();

  return useStyle(() => {
    return {
      width: width * proportion,
      height: width * proportion * aspectRatio,
    };
  }, [width, proportion, aspectRatio]);
}
